import React, { useState } from 'react';
import PortfolioContainer from './portfolioContainer';

const PortfolioPage = () => {
    const [activeFilter, setActiveFilter] = useState('*');

    return (
        <>
            <section id="portfolio" className="portfolio py-5 mt-5">
                <div className="container" data-aos="fade-up">
                    <div className="section-title text-center mb-5">
                        <h2 className="fw-bold text-uppercase position-relative d-inline-block pb-2">Portfolio</h2>
                        <p className="text-muted mt-2">
                            Selected engineering systems and academic research implementations across wireless security and fullstack development.
                        </p>
                    </div>
                    
                    {/* Professional Category Filters */}
                    <div className="row" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-lg-12 d-flex justify-content-center mb-4">
                            <ul id="portfolio-flters" className="list-inline">
                                <li 
                                    className={`mx-2 px-3 py-1 text-uppercase fw-semibold small transition-all rounded ${activeFilter === '*' ? 'filter-active' : ''}`} 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setActiveFilter('*')}
                                >
                                    All Projects
                                </li>
                                <li 
                                    className={`mx-2 px-3 py-1 text-uppercase fw-semibold small transition-all rounded ${activeFilter === '.filter-research' ? 'filter-active' : ''}`} 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setActiveFilter('.filter-research')}
                                >
                                    Research & Wireless Security
                                </li>
                                <li 
                                    className={`mx-2 px-3 py-1 text-uppercase fw-semibold small transition-all rounded ${activeFilter === '.filter-enterprise' ? 'filter-active' : ''}`} 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setActiveFilter('.filter-enterprise')}
                                >
                                    Enterprise Web Applications
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <PortfolioContainer activeFilter={activeFilter} />
                </div>
            </section>
        </>
    );
};

export default PortfolioPage;